/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {FamilyAccountsLockIssuedCardsRequest} from '@cash-web/protos/squareup/cash/postcard/app/FamilyAccountsLockIssuedCards.pb'
import {FamilyAccountsLockIssuedCardsResponse} from '@cash-web/protos/squareup/cash/postcard/app/FamilyAccountsLockIssuedCards.pb'


export const familyAccountsLockIssuedCards = (request: FamilyAccountsLockIssuedCardsRequest, options?: CashRequestOptions) => post<FamilyAccountsLockIssuedCardsRequest, FamilyAccountsLockIssuedCardsResponse>("/2.0/cash/family-accounts-lock-issued-cards", request, {...options, rejectOnError: true })